import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import {RgpdResponseDTO} from '../../../model/dto/rgpd-response.dto';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
    selector: 'app-dialog-rgpd-accept',
    templateUrl: './dialog-rgpd-accept.component.html',
    styleUrls: ['./dialog-rgpd-accept.component.scss'],
    providers: [
        { provide: MAT_DIALOG_DATA, useValue: {} }
    ],
    imports: [FormsModule, ReactiveFormsModule, MatDialogTitle, MatCheckboxModule]
})
export class DialogRgpdAcceptComponent implements OnInit {
    dialogRef = inject<MatDialogRef<DialogRgpdAcceptComponent>>(MatDialogRef);
    data = inject(MAT_DIALOG_DATA);
    private readonly fb = inject(UntypedFormBuilder);


    result;
    formGroupRGPD: UntypedFormGroup = null;
    year;
    rgpdResponse: RgpdResponseDTO;

    ngOnInit() {
        this.formGroupRGPD = this.fb.group({
            isInformationValid: [null, Validators.required],
            canTakePhotos: [null],
            isRGPDReaded: [null, Validators.required],
            canContactResponsable: [null]
        });

        this.rgpdResponse = new RgpdResponseDTO();

        this.formGroupRGPD.controls.isInformationValid.valueChanges.subscribe((value: boolean) => {
            this.rgpdResponse.isInformationValid = value;
        });
        this.formGroupRGPD.controls.canTakePhotos.valueChanges.subscribe((value: boolean) => {
            this.rgpdResponse.canTakePhotos = value;
        });
        this.formGroupRGPD.controls.isRGPDReaded.valueChanges.subscribe((value: boolean) => {
            this.rgpdResponse.isRGPDReaded = value;
        });
        this.formGroupRGPD.controls.canContactResponsable.valueChanges.subscribe((value: boolean) => {
            this.rgpdResponse.canContactResponsable = value;
        });

        if (this.year) {
            this.formGroupRGPD.controls.canTakePhotos.setValue(this.year.imageRightAutorization ? this.year.imageRightAutorization : false);
            this.formGroupRGPD.controls.isRGPDReaded.setValue(this.year.acceptedRGPD ? this.year.acceptedRGPD : false);
            this.formGroupRGPD.controls.canContactResponsable.setValue(this.year.contactAccepted ? this.year.contactAccepted : false);

            this.rgpdResponse.idYear = this.year.id;
        }
    }

    Fermer() {
        this.dialogRef.close(this.rgpdResponse);
    }
}
